export enum CreateActionId {
  Invoice = 'invoice',
  Quote = 'quote',
  Contact = 'contact',
}
